/**
 * 语文听写（**系统管理员**）：字表的**维护**页 —— `/admin/dictation`。
 *
 * ## 为什么维护搬到了这里（用户原话）
 *
 * > "这个语文听写录入这个字词组成语……放在某个家长下面，我觉得就不太合适。
 * >  你想，是不是每个家长注册之后，每个家庭那个家长都要录一遍这个字啊？
 * >  那岂不是太浪费时间，而且没有办法资源重用吗？所以我觉得这个工具类应该……
 * >  **不是家长负责维护，而应该是站点负责维护**。站点提供这个工具，
 * >  这工具家长拿到就能用，他不需要录入那些语文书上那些字词。……
 * >  所以我觉得**录入维护这一块应该由系统管理员去做**，应该放到系统管理员那里去。"
 *
 * 数据本身早就是站点级的（`textbook` / `lesson` / `hanzi` / `hanzi_listing` /
 * `word` / `word_hanzi` / `word_lesson` / `hanzi_lesson` 八张表里**没有**
 * `student_id`，也没有别的家庭归属）—— 所以这次搬的是**权限与界面位置**，
 * **没有搬任何数据**。
 *
 * ## 界面复用，不重写
 *
 * 这一页与家长端的 `/tools/dictation` **共用同一个** `DictationWorkspace`，
 * 只把 `mode` 换成 `maintain`、`scope` 换成 `{ kind: 'admin' }`：
 * 面板（`DictationImportPanel` / `DictationBooksPanel` / `DictationItemsPanel` /
 * `HanziReadingsModal` / `DictationItemForm` …）一行都没重写。
 *
 * ## 门禁是**两层**，缺一不可
 *
 *   1. 前端：`RequireSystemAdmin`（见 `App.tsx`）—— 非管理员看不到这一页；
 *   2. 后端：`/admin/dictation/*` 走 `lib/admin-gate.ts` 的 `requireSystemAdmin`
 *      （角色 + 已绑定动态口令 + 账号未停用），与账号管理、系统设置同一道门禁。
 *      Caddy 另外把 `/api/v1/admin/*` 限制在内网 / SSH 隧道来源
 *      （**该限制线上尚未生效**，见 docs/RUNBOOK.md §5.4）。
 *
 *    ⚠️ 前端的守卫只是"别让人走到一个满屏 403 的页面"，**不是安全边界**。
 */
import { AdminShell } from '../../components/layout/AdminShell';
import { DictationWorkspace } from '../../components/dictation/DictationWorkspace';

export function AdminDictationPage() {
  return (
    <AdminShell
      title="听写字表"
      description="站点共享的语文听写内容：课本、课文、生字、词语，以及识字表 / 写字表 / 词语表的收录。家长能看、能选词、能布置听写，改不了。"
    >
      <div className="space-y-4">
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
          {/*
            ⚠️ 这句提示是**给管理员看的边界说明**，不是给家长的。
               "录音"那一条尤其重要：它**不在**这里维护 ——
               录音是按家长归属的（家庭专属），管理员改拼音会改到所有家庭，
               但录不了、也不该替别人录音。
          */}
          这里改的是<strong>所有家庭共用</strong>的字表。多音字的读音在这里统一纠正
          （一个字只有一个正确读法）。家长自己录的朗读音**不在这里** ——
          那是每个家庭自己的声音，按录它的家长归属，别的家庭听不到。
        </div>

        <DictationWorkspace scope={{ kind: 'admin' }} mode="maintain" />
      </div>
    </AdminShell>
  );
}
